import { forwardRef } from 'react';
import { StyledTextField, TextInputProps } from './TextInput';
import { CommonLabelSeparateProps } from './types';

export type NumberInputProps = CommonLabelSeparateProps &
  TextInputProps & {
    numberOnly?: boolean;
    allowSignedValues?: boolean;
    type?: 'number';
  };

export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ onChange, onBlur, numberOnly, allowSignedValues, variant, ...rest }, ref) => {
    return (
      <StyledTextField
        {...rest}
        InputLabelProps={{ shrink: true }}
        variant={variant === 'unstyled' ? 'standard' : variant}
        onChange={e => {
          e.stopPropagation();
          e.preventDefault();

          const value = e.target.value;

          const shouldTriggerChange =
            (/^[+-]?\d*$/.test(value) && numberOnly && allowSignedValues) ||
            (/^[+-]?(\d+\.?\d*|\d*\.\d*)?$/.test(value) && allowSignedValues) ||
            (/^\d*$/.test(value) && numberOnly) ||
            /^\d*\.?\d*$/.test(value);

          if (shouldTriggerChange) {
            onChange?.(e);
          }
        }}
        onBlur={e => {
          onBlur?.(e);
        }}
        inputRef={ref}
      />
    );
  }
);

NumberInput.displayName = 'NumberInputField';
